// value is the label for the file type in key
export const allowedFileTypesForAiGrading = {
  txt: 'txt',
  text: 'text',
  doc: 'doc',
  docx: 'docx',
  pdf: 'pdf',
  png: 'png',
  jpg: 'jpg',
  jpeg: 'jpeg',
  jfif: 'jfif',
  webp: 'webp',
  gif: 'gif (non-animated)',
  bmp: 'bmp',
  tiff: 'tiff',
  tif: 'tif',
} as const;
